
import { emitEventBuss } from "../../../global";
import { Selection } from "../nodes/_service/selectionService"
import { Redo, Undo } from "../nodes/_service/undoRedo"

export const ShortCuts = {
  Init: (that) => {
    let serviceSelection = new Selection()
    let moveDistance = 0.5;
    let moveObj = {
      ArrowUp: { x: 0, y: -moveDistance },
      ArrowRight: { x: moveDistance, y: 0 },
      ArrowDown: { x: 0, y: moveDistance },
      ArrowLeft: { x: -moveDistance, y: 0 },
    }

    document.onkeydown = async function (event) {
      switch (event.key) {
        case 'Delete':
          that.removeNode();
          break;
        case 'Escape': 
          that.unSelected();
      }

      if (event.ctrlKey && event.key === 'c') {
        console.log("Copiar")
        serviceSelection.copy();
      }

      if (event.ctrlKey && event.key === 'v'){
        console.log("Colar")
        serviceSelection.cut(that.openDialog);
      }
      
      if (event.ctrlKey && event.key === 'z'){
        console.warn("ctrl-z");
        await Undo(that);
        that.unSelected();
      }

      if (event.ctrlKey && event.key === 'y'){
        console.warn("ctrl-y");
        await Redo(that);
        that.unSelected();
      }

      if (event.ctrlKey && event.key === 'q'){
        emitEventBuss("OpentToolsNode", null)
      }

      if (moveObj[event.key]) {
        const {x, y} = moveObj[event.key];
        serviceSelection.arrowMove(x, y);
      }
    }
  },
  Kill: () => {
    document.onkeydown = null;
  }
}